import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";

import { VTCContent } from "@/components/pages/vtc/VTC";
import { queryVTCLyon } from "@/strapiQuery/vtcLyon";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const vtcContentPromise = getStrapiEntity<VTCContent>(
    "vtc-lyon",
    queryVTCLyon
  );

  const [layout, vtcContent] = await Promise.all([
    layoutPromise,
    vtcContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...vtcContent,
      intlMessages,
      defaultCanonicalRoute: routes.vtcLyon,
    },
    revalidate: 10,
  };
};

export { VTCLyon as default } from "@/components/pages/vtcLyon/VTCLyon";
